<a
  *ngFor="let item of pages$ | async"
  [class]="item.type"
  [class.disabled]="isInactive(item)"
  [class.current]="isCurrent(item)"
  [routerLink]="pageRoute"
  [queryParams]="getQueryParams(item)"
  [tabIndex]="isInactive(item) ? -1 : 0"
  (click)="!isCurrent(item) && pageChange(item)"
>
  <div [ngSwitch]="item.type">
    <ng-container *ngSwitchCase="itemTypes.NEXT">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="itemTypes.PREVIOUS">
      <ng-container *ngTemplateOutlet="icon"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>{{ item.label }}</ng-container>

    <ng-template #icon>
      <cx-icon [type]="iconType.ARROW_EXPAND"></cx-icon>
    </ng-template>
  </div>
</a>
